
import { BreakPoints, OrientationHandler } from '../../shared';
import SwiperSlider from '../../swiper/swiper-slider.js';
export default class CoverSlider extends BreakPoints {

  constructor(context) {
    super();
    this.context = context;
    this.controls = context.querySelector('[data-swiper-controls]');


    this.settings = {
      resize: {
        xs: 3,
        md: 4,
        lg: 7.8,
        landscape: 7.8
      }
    }
    this.resizeValue = this.settings.resize.md;
    this.init();
  }

  init() {
    this.orientationHandler = new OrientationHandler();
    this.onSliderResize = this.onResize.bind(this);
    this.onSliderResize();

    this.on('change', (item) => {
      this.setResizeSize(item);
      this.setHeight();
    })

    SwiperSlider.init(this.context)
  }

  setResizeSize(item) {
    const currentOrientation = this.orientationHandler.getCurrent();
    if (currentOrientation === 'landscape') {
      this.resizeValue = this.settings.resize.landscape;
    } else {
      if(!item) return;
      const {e, mq, queryList} = item;
      switch (mq.name) {
        case 'xxs':
        case 'xs':
          this.resizeValue = this.settings.resize.xs;
          break;
        case 'sm':
        case 'md':
          this.resizeValue = this.settings.resize.md;
          break;
        default:
          this.resizeValue = this.settings.resize.lg;
      }
    }
  }

  onResize(orientation) {
    this.setResizeSize();
    this.setHeight();
  }

  setHeight() {
    const wrapperWidth = window.innerWidth / this.resizeValue;
    this.controls.style.width = `${wrapperWidth}px`;
    this.height = CoverSlider.calculateHeight(wrapperWidth);
    this.controls.style.height = `${this.height}px`;
  }

  static calculateHeight = (node, ratio) => {
    const aspectRatio = ratio || 1 / 2;
    const itemWidth = node || window.innerWidth;
    return parseFloat((itemWidth / aspectRatio).toFixed(2));
  };
}
